export default __webpack_public_path__ + "static/media/menu-manajemen.9f425315.svg";